module.exports = __webpack_public_path__ + "img/9.c006d7ff.png";